// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ViXW","col":"styles_col__2JfHI"};